import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/strategy")({
  beforeLoad: ({ context }) => requireRoute(context, "/strategy"),
});
